import InputSearch from "ui/components/Input/InputSearch";

export interface HeaderTableProps {
  onSearch: (q?: string) => void;
  value: string;
}

function HeaderTable({ onSearch, value }: HeaderTableProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <div style={{ flex: 1 }}>
        <InputSearch
          defaultValue={value}
          onSearch={(v) => onSearch(v)}
          placeholder="Procurar por nome da unidade ou proprietário"
          maxW="100%"
        />
      </div>
    </div>
  );
}

export default HeaderTable;
